import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  isShow: false,
  title: '',
  showCloseBtn: false,
  msg: '',
  btn: {
    confirm: {
      text: '',
      callback: null
    }
  }
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showNotification: (state, action) => ({
      isShow: true,
      title: action.payload.title,
      showCloseBtn: action.payload.showCloseBtn,
      msg: action.payload.msg,
      btn: { ...action.payload.btn }
    }),
    hideNotification: (state) => ({
      ...initialState
    })
  }
});

export const { showNotification, hideNotification } = notificationSlice.actions;
export const useNotificationSliceSelector = createSelectorFn(notificationSlice);
export default notificationSlice;
